export default function styles(theme) {
    return {
      title: {
        fontFamily: "philosopher",
        fontWeight: "bold",
        fontSize: "5rem",
        textTransform: "uppercase",
        letterSpacing: "5px",
        "-webkit-text-fill-color": "transparent",
        " -webkit-text-stroke": " .1px #B6CFFF"
      },
      card: {
        height: "max-content",
        margin: 0,
        backgroundColor: theme.palette.primary.main,
        border: "1px solid rgba(121, 131, 150, 0.2)",
        borderRadius: 8,
        transition: "1s all ease-in-out",
        background: "rgb(25,25,25,0)",
        "&:hover":{
          background: "rgb(25,25,25,0.5)",
        },
      },
      media: {
        borderRadius: 8,
        margin: 0,
        // border: "1px solid rgba(121, 131, 150, 0.2)",
        height: "12.5rem",
        width:"100%",
        background: "rgb(142,162,199,0.1)",
        [theme.breakpoints.down("sm")]: {
          height: "13rem",
        }
      },
      cardWrapper: {
        width: "100%",
      },
      alignedCard: {
        alignSelf: "center"
      },
      cardDetails: {
        display: "flex",
        justifyContent: "space-between",
        marginTop: "10px",
      },
      price:{
        color: 'lightgreen',
        fontWeight:'400',
      },
      tagName: {
        color: theme.palette.text.tertiary,
        padding: "8px 15px",
        backgroundColor: "rgb(93,95,239,0.15)",
        borderRadius: 8,
        width: "fit-content",
        fontSize: "0.8rem"
      },
      imageOverlay:{
        position: "absolute",
        borderRadius: 8,
        height: "100%",
        width: "100%",
        opacity: 0.2,
        transition: ".5s ease",
        backgroundColor: "#5D5FEF",
        "&:hover":{
          opacity: 0,
        },
      },
    };
  }
  